import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DialogBoxDataModel } from "./dialogBoxDataModel";
@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss']
})
export class DialogBoxComponent implements OnInit {

  title: string;
  message: string;
  useColorButton: boolean;
  yesButton: boolean;
  noButton: boolean;
  cancelButton: boolean;
  yesFocused: boolean;
  noFocused: boolean;
  cancelFocused: boolean;
  yesTitle: string = 'بلی';
  noTitle: string = 'خیر';
  cancelTitle: string = 'انصراف';
  constructor(public dialogRef: MatDialogRef<DialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogBoxDataModel) { }

  ngOnInit() {
    this.title = this.data.title;
    this.message = this.data.message;
    this.useColorButton = this.data.useColorButton;
    let type = this.data.dialogType;

    switch (type) {
      case "YesNo":
        this.yesButton = true;
        this.noButton = true;
        this.yesFocused = true;
        if (this.data.yesTitle)
          this.yesTitle = this.data.yesTitle;
        if (this.data.noTitle)
          this.noTitle = this.data.noTitle;
        break;
      case "OkOnly":
        this.yesButton = true;
        this.yesFocused = true;
        if (this.data.okTitle)
          this.yesTitle = this.data.okTitle;
        else this.yesTitle = 'باشه';
        break;
      case "YesNoCancel":
        this.yesButton = true;
        this.noButton = true;
        this.cancelButton = true;
        this.yesFocused = true;
        if (this.data.yesTitle)
          this.yesTitle = this.data.yesTitle;
        if (this.data.noTitle)
          this.noTitle = this.data.noTitle;
        if (this.data.cancelTitle)
          this.cancelTitle = this.data.cancelTitle;
        break;
    }
  }
  noClick(): void {
    this.dialogRef.close("no");
  }
  yesClick(): void {
    this.dialogRef.close("yes");
  }
  cancelClick(): void {
    this.dialogRef.close("cancel");
  }
}
